export function mergeObservationMediaPointSpecies(input: MergeObservationMediaPointSpeciesInput[]) {
    const groupedOnSpecies = Object.groupBy(input, x => x.species.id);

    return Object.values(groupedOnSpecies).map(element_ => {
        const element = element_ ?? [];

        return {
            species: element[0].species,
            processors: element.map(x => ({
                label: x.processor,
                confidence: x.confidence,
                detections: x.detections,
            })),
        };
    });
}

interface MergeObservationMediaPointSpeciesInput {
    species: {
        id: string;
        name: string;
    };
    processor: string;
    confidence: number;
    detections: number;
}
